<template>
    <div>
      <b-modal
        v-model="modalOpen"
        footer-class="removed"
        centered
        no-close-on-backdrop
        v-bind="$attrs"
        v-on="$listeners"
        :title="mainTitle"
      >
        <slot name="body">
            
      <div class="">
        <validation-observer ref="branchValidation">
          <b-form @submit.prevent="onSubmit">
            <b-row>

              <b-col cols="12">
                <b-form-group label="أوجه الإنفاق المُراد توظيف الإعامة فيها" label-for="details" class="my-1">
                  <validation-provider
                    #default="{ errors }"
                    name="أوجه الإنفاق المُراد توظيف الإعامة فيها"
                    rules="required"
                    id="details"
                    mode="passive"
                  >
                    <quill-editor
                      :options="editorOption"
                      v-model="form.expenditures"
                      :class="{ quillEditor: errors.length > 0 }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              
              <b-col cols="12">
                <form-select
                  label="الحساب المصرفي المُراد تحويل إليه"
                  :getOptionLabel="(x) => x.account_no"
                  :reduce="(x) => x"
                  id="resGov"
                  ep="v2/selects/bank-accounts"
                  ref="resGov"
                  rules="required"
                  v-model="form.ngo_bank_account_id"
                />
              </b-col>
              
            </b-row>
            <hr />

            <b-row class="px-1 justify-content-end">
              <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
              <save-btn
                type="submit"
                variant="success"
                :loading="loading"
                :label="btnLabel"
              >
              </save-btn>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
        </slot>
      </b-modal>
  </div>
  </template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import "quill/dist/quill.snow.css";
import FormAutocomplete from "@/components/form-autocomplete";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormAutocomplete
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
 
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
